var data = {
	"body": "<path d=\"M1899 1023.999c0-483.252-391.75-874.995-875-874.995S149 540.747 149 1024c0 483.251 391.75 875.004 875 875.004s875-391.753 875-875.004z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"100.04248826\"/>",
	"width": 2048,
	"height": 2048
};
exports.__esModule = true;
exports.default = data;
